import { FirmanteColorTokens } from '../../Envios/documentos/components/configuracion-panel-firmantes-unificado/firmante-color.tokens';
import { EmpleadoCrud } from 'src/app/pages/empleados/models/empleado';

/** Destinatario del paso Envio (datos de contacto + metadata visual del paso Firmantes). */
export interface FirmanteEnvioSimple {
  codigo: string;
  desc: string;
  orden: number;
  esPrincipal: boolean;
  esValidador: boolean;
  color: FirmanteColorTokens;
  nombre: string;
  apellido1: string;
  apellido2: string;
  email: string;
  telefono: string;
  /** Codigo del empleado en maestro, si se selecciono desde busqueda. */
  codigoEmpleado?: string;
  /** Snapshot ampliado del empleado (edicion en panel lateral; persistencia en BD segun rol). */
  datosEmpleado?: Partial<EmpleadoCrud>;
}

export interface MensajeCorreoEnvioSimple {
  subject: string;
  body: string;
  bodySMS: string;
}

export interface AjustesEnvioSimple {
  recordatorio: boolean;
  recordatorios: (number | null)[];
  caducidad: number;
  envioParalelo: boolean;
}

export interface CanalesEnvioSimple {
  envioMail: boolean;
  envioSMS: boolean;
  /** Preferencia global de origen de e-mail (codigo catalogo tiposMails). No se envia al back. */
  ordenMail: string;
  /** Preferencia global de origen de telefono SMS. No se envia al back. */
  ordenTelefonoSMS: string;
}

export function crearMensajeCorreoVacio(): MensajeCorreoEnvioSimple {
  return { subject: '', body: '', bodySMS: '' };
}

export function crearAjustesEnvioPorDefecto(): AjustesEnvioSimple {
  return {
    recordatorio: false,
    recordatorios: [null],
    caducidad: 365,
    envioParalelo: false
  };
}

export function crearCanalesPorDefecto(): CanalesEnvioSimple {
  return {
    envioMail: true,
    envioSMS: false,
    ordenMail: 'Personal',
    ordenTelefonoSMS: 'Personal'
  };
}
